export const modalTranslation = {
    es : {
        updateBilling: {
            important: 'Nos renovamos',
            title: "Descubre lo nuevo de tu membresía",
            subtitle: "Actualiza tu membresía para hacer descubrir una mejor experiencia al viajar con tu membresía. Actualiza los datos de pago de tu siguiente renovación para continuar.",
            update: "Actualizar mis datos",
            later : "Más tarde"
        },
        addCompanions: {
            note: 'Añade acompañantes hasta el',
            title: 'Agrega más acompañantes a tu membresía',
            subtitle : 'Comparte el beneficio de descuento Viva Fan con hasta 8 personas. Recuerda que deben estar incluidas en tu reserva para que disfruten el descuento.',
            buttonText : 'Mejorar membresía'
        },
        translations: {
            title: 'Preferencias de compra',
            currency: "Moneda",
            language: "Idioma",
            mxn: 'Pesos mexicanos',
            dollar: 'Dólar estadounidense',
            eng: 'Inglés - USA',
            es: 'Español - MEX',
            buttonText: "Confirmar"
        },
        upgrade : {
            note: '',
            title: 'Viaja acompañado desde $49mxn al mes',
            subtitle : 'Comparte los descuentos de Viva Fan hasta con 8 personas.',
            buttonText : 'Actualizar membresía'
        },
        activate: {
            note: '',
            title: '¡No pierdas tus beneficios!',
            subtitle : 'Activa la renovación automática para no perder tus beneficios',
            buttonText : 'Activar renovación automática'
        },
        reactivate: {
            note: '',
            title: `Renovación de membresía `,
            subtitle : ( date ) =>  `Tu membresía se renovará automáticamente el ${date} y disfrutarás de un año más de beneficios Viva Fan `,
            buttonText : 'Activar Renovación',
            buttonCancel : 'Cancelar'
        },
        cancel : {
            title: "¿Quieres cancelar la renovación automática?",
            subtitle: (date) => { return `Recuerda que tu membresía tiene una duración obligatoria de 12 meses y <strong> se mantendrá vigente   hasta el ${date}. </strong> Con esta opción cancelarás la renovación por un siguiente año.`},
            buttonText: "Cancelar renovación",
            buttonClose: "Cerrar"
        }
        
    },
    eng : {
        updateBilling: {
            important: 'Important',
            title: "Discover what's new in your membership",
            subtitle: "Update your payment method now and avoid interruption of your membership.",
            update: "Update your data",
            later : "Later"
        },
        addCompanions: {
            note: 'Add companions until',
            title: 'Add more companions to your membership',
            subtitle : 'Share the Viva Fan discount benefit with up to 8 people. Remember that they must be included in your reservation to enjoy the discount.',
            buttonText : 'Upgrade membership'
        },
        translations: {
            title: 'Purchasing preferences',
            currency: "Currency",
            language: "Language",
            mxn: 'Mexican Peso',    
            dollar: 'US Dollar',
            eng: 'English - USA',
            es: 'Spanish - MEX',
            buttonText: "Confirm"
        },
        upgrade : {
            note: '',
            title: 'Travel accompanied from $49mxn per month',
            subtitle : 'Share Viva Fan discounts with up to 8 people.',
            buttonText : 'Upgrade membership'
        },
        activate: {
            note: '',
            title: `Don't lose your benefits`,
            subtitle : `Activate automatic renewal so you don't lose your benefits at the end of your subscription year`,
            buttonText : 'Activate Automatic Renewal'
        },
        reactivate: {
            note: '',
            title: `Membership renewal`,
            subtitle : ( date ) =>  `Your membership will be automatically renewed on ${date} and you will enjoy one more year of Viva Fan benefits `,
            buttonText : 'Activate renewal',
            buttonCancel: 'Cancel'
        },
        cancel : {
            title: "Do you want to cancel the automatic renewal?",
            subtitle: (date) => { return `Remember that your membership has a mandatory duration of 12 months and will remain <strong>   valid until ${date} </strong> . With this option you will cancel the renewal for a following year.`},
            buttonText: "Cancel renewal",
            buttonClose: "Close"

        }
    }
}